import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_EXPORT_SIGNATURE_BLOCKLIST = createFcmDetails('export_signature_blocklist', {
	owner: 'Starter Activation',
	context: 'blocked_signature_export',
	description: 'FCM to block signature export for a petition by country code.',
	import: false,
	template: {
		petitionIds: ['12345', '67890'],
		countryCodeIds: ['US', 'CA'],
	},
});
